import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import TipDialogueBox from 'components/Shared/TipDialogueBox'
import { api } from 'api/_init'

function MergesComponent(props) {
  const { mergedPackages } = props
  const { t } = useTranslation()
  const [packageTitles, setPackageTitles] = useState([])

  useEffect(() => {
    const fetchPackageTitles = async () => {
      if (!mergedPackages || mergedPackages.length === 0) {
        setPackageTitles([])
        return
      }

      try {
        const promises = mergedPackages.map(async (packageId) => {
          try {
            const { data, status } = await api.get(`/package_builder/packages/${packageId}`)
            if (status === 200 && data && data.title) {
              return data.title
            }
            return null
          } catch (error) {
            console.error(`Error fetching package ${packageId}:`, error)
            return null
          }
        })

        const titles = await Promise.all(promises)
        // Filter null values (errors)
        const validTitles = titles.filter((title) => title !== null)
        setPackageTitles(validTitles)
      } catch (error) {
        console.error('Error fetching package titles:', error)
        setPackageTitles([])
      }
    }

    fetchPackageTitles()
  }, [mergedPackages])

  const textContent = t('PackageBuilder.packageBuilderResults.merges', { mergedPackages: packageTitles.join(', ') })

  return (
    <TipDialogueBox
      text={textContent}
      variant="info"
    />
  )
}

export default MergesComponent

MergesComponent.propTypes = {
  mergedPackages: PropTypes.arrayOf(PropTypes.string).isRequired,
}